import { Outlet, useNavigate } from "react-router-dom";
import { SidebarTrigger, SidebarInset } from "@/components/ui/sidebar"
import { AppSidebar } from "@/components/app-sidebar"
import Header from "../components/header"
import { CartSheet } from "modules/cart/components/cartSheet";
import { PageTitleProvider, usePageTitle } from "hooks/usePageTitle";
import { CartSheetProvider, useCartSheet } from "hooks/useCartSheet";
import { ArrowLeft, MessageCircleQuestion } from "lucide-react";
import { PwaInstallBanner } from "./pwa-install-banner";

function HeaderBar() {
  const { title, showBack } = usePageTitle();
  const { open, setOpen } = useCartSheet();
  const navigate = useNavigate();

  return (
    <header className="flex justify-between h-20 shrink-0 items-center gap-2 border-b pl-4 pr-6 py-2">
      <div className="flex items-center gap-4">
        {showBack ? (
          <button onClick={() => navigate(-1)} className="flex items-center gap-1 text-sm font-medium text-foreground">
            <ArrowLeft className="h-4 w-4" />
          </button>
        ) : (
          <SidebarTrigger className="-ml-1" />
        )}
        <h2 className="text-xl font-semibold">{title}</h2>
      </div>
      <div className="flex items-center gap-2">
        <div> 
          <a href="https://wa.me/56989326529" target="_blank" rel="noopener noreferrer" className="underline">
           <MessageCircleQuestion className="w-5 h-5"/>
          </a>
        </div>
        <CartSheet open={open} setOpen={setOpen} />
      </div>
    </header>
  );
}

export default function MainLayout() {
  return (
    <>
      <AppSidebar variant="inset" />
      <SidebarInset className="min-w-0">
        <PageTitleProvider>
          <CartSheetProvider>
            <HeaderBar />
            <Outlet />
          </CartSheetProvider>
        </PageTitleProvider>
      </SidebarInset>
      <PwaInstallBanner />
    </>
  )
}
